// const $ = jQuery;
(function ($) {
  // Check if tabItems exist.
  const tabItem = $(".tab-item > button");

  if (tabItem.length) {
    // Click handler.
    const handleTabClick = (e) => {
      let listItem = $(e.target.closest("li"));
      listItem.toggleClass("is-active");
      let tabName = listItem[0].children[0].dataset.show;
      e.preventDefault();

      // Update localStorage on each tab click.
      localStorage.setItem("event-tab_active", tabName);
      setActiveTab(tabName);
    };

    // Register click handler
    tabItem.on("click", handleTabClick);

    // Try to retrieve active tab from localStorage.
    let activeTab = localStorage.getItem("event-tab_active");

    if (activeTab) {
      setActiveTab(activeTab);
    } else {
      setDefaultTab();
    }
  }

  function setDefaultTab() {
    let defaultTab = $(".tab-item.default > button")[0];
    setActiveTab(defaultTab.dataset.show);
  }

  function setActiveTab(tabId) {
    // Clear all tabs.
    $(".tabs__items .tab-item").removeClass("is-active");

    // Set active tab.
    $("[data-show=" + tabId + "]")
      .parent()
      .addClass("is-active");

    // Hide all content areas.
    $(".tabs__content-wrapper").removeClass("is-visible");

    // Show active content area.
    $("#" + tabId).addClass("is-visible");
  }
})(jQuery);
